import styled, { keyframes } from 'styled-components'

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

export const ModalBackdrop = styled.div<{ $position?: 'fixed' | 'absolute' }>`
  position: ${({ $position = 'fixed' }) => $position};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
`

export const ModalContainer = styled.div`
  border-radius: 0.5rem;
  background: rgba(35, 35, 35, 0.7);
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 1.5rem;
  color: white;
  line-height: 1.25rem;
  text-align: center;
  width: 24rem;
  max-width: 90vw;
  display: flex;
  flex-direction: column;
  position: relative;
  opacity: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  animation: ${fadeIn} 0.2s ease-out forwards;
`

export const ModalTitle = styled.h3`
  margin: 0 0 0.75rem 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: white;
  letter-spacing: 0.025rem;
  opacity: 0.95;
`

export const ModalMessage = styled.p`
  margin: 0 0 1.5rem 0;
  font-size: 0.875rem;
  opacity: 0.9;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.85);
  white-space: pre-line;
`

export const ModalButtonContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: center;
`
